import { CalculatorFormState, ROIResults } from '../types';

const toDecimal = (value: number): number => value / 100;

export const calculateROI = (input: CalculatorFormState): ROIResults => {
    const bookingRate = toDecimal(input.bookingRate);
    const showRate = toDecimal(input.showRate);
    const closeRate = toDecimal(input.closeRate);
    const retentionRate = toDecimal(input.retentionRate);

    const bookedAppointments = input.monthlyLeads * bookingRate;
    const completedAppointments = bookedAppointments * showRate;
    const closedClients = completedAppointments * closeRate;

    const netNewRevenue = closedClients * input.averageOrderValue;
    const retentionRevenue =
        closedClients * retentionRate * input.averageOrderValue * Math.max(input.retentionMonths, 0);

    const totalRevenue = netNewRevenue + retentionRevenue;
    const marketingSpend = input.marketingSpend;
    const fixedCosts = input.fixedCosts;
    const totalCost = marketingSpend + fixedCosts;

    const netProfit = totalRevenue - totalCost;
    const roi = totalCost > 0 ? (netProfit / totalCost) * 100 : 0;
    const costPerAcquisition = closedClients > 0 && totalCost > 0 ? totalCost / closedClients : null;
    const averageCustomerValue = closedClients > 0 ? totalRevenue / closedClients : null;
    const paybackPeriodMonths = totalRevenue > 0 && totalCost > 0 ? totalCost / totalRevenue : null;

    return {
        bookedAppointments,
        completedAppointments,
        closedClients,
        netNewRevenue,
        retentionRevenue,
        totalRevenue,
        marketingSpend,
        fixedCosts,
        totalCost,
        netProfit,
        roi,
        costPerAcquisition,
        averageCustomerValue,
        paybackPeriodMonths,
    };
};

export const formatROI = (roi: number): string => `${roi.toFixed(2)}%`;
